const LENGTH_OPTIONS = [2, 3, 4]

export default function MesoBlockLengthSelector({ selectedLength, setSelectedLength }) {

    const selectedIndex = Math.max(0, LENGTH_OPTIONS.indexOf(selectedLength))

    return (
        <div
            role="radiogroup"
            aria-label="Block length"
            className="relative flex items-stretch rounded-md border border-gray-400"
            onClick={(event) => event.stopPropagation()}
            onMouseDown={(event) => event.stopPropagation()}
        >
            <div
                aria-hidden="true"
                className="pointer-events-none absolute -inset-y-px rounded-md border border-white transition-[left,width] duration-200 ease-out"
                style={{
                    left: `calc(${(selectedIndex / LENGTH_OPTIONS.length) * 100}% - 1px)`,
                    width: `calc(${100 / LENGTH_OPTIONS.length}% + 2px)`,
                }}
            />

            {LENGTH_OPTIONS.map((length) => {
                const isSelected = selectedLength === length

                return (
                    <button
                        key={length}
                        type="button"
                        role="radio"
                        aria-checked={isSelected}
                        className={`
                            relative z-10 flex-1 min-w-6 px-2.5 py-0.5 text-center cursor-pointer
                            ${isSelected ? 'text-white text-sm font-bold' : 'text-sm text-gray-400'}
                        `}
                        onClick={(event) => {
                            event.stopPropagation()
                            setSelectedLength(length)
                        }}
                    >
                        {length}
                    </button>
                )
            })}
        </div>
    )
}
